import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrivacyacceptanceService {

  @Output() change: EventEmitter<boolean> = new EventEmitter();
  private subject = new Subject<any>();
  constructor() { }

  toggle(data) {
    this.change.emit(data);
  }

  sendPrivacyAcceptance(privacyStatementFlag: boolean) {
    this.subject.next({ text: privacyStatementFlag });
  }

  clearPrivacyAcceptance() {
    this.subject.next();
  }

  getPrivacyAcceptance(): Observable<any> {
    return this.subject.asObservable();
  }

}
